export const TABLE_COLUMNS = [
  {
    Header: "Program Name",
    accessor: "program_name",
  },
  {
    Header: "Requested by",
    accessor: "",
    Cell: ({ cell }) => {
      return (
        <span>
          {cell.row.original?.awarder_first_name} {cell.row.original?.awarder_last_name}
        </span>
      );
    },
  },
  {
    Header: "Recipient",
    accessor: "",
    Cell: ({ cell }) => {
      return (
        <span>
          {cell.row.original?.participant_first_name} {cell.row.original?.participant_last_name}
        </span>
      );
    },
  },
  {
    Header: "Event Name",
    accessor: "event_name",
  },
  {
    Header: "Amount",
    accessor: "amount",
    Cell: ({ value }) => {
      return <span>{value ? parseFloat(value).toFixed(2) : ''}</span>;
    },
  },
  {
    Header: "Scheduled Date",
    accessor: "scheduled_date",
    width: 220,
    minWidth: 220,
    maxWidth: 220,
    Cell: ({ value }) => {
      if (!value) return <span></span>;
      const dateStr = value.replace(' ', 'T');
      const parsed = new Date(dateStr);
      return <span>{isNaN(parsed.getTime()) ? '' : parsed.toLocaleDateString("en-US", {})}</span>;
    },
  },
  {
    Header: "Date Created",
    accessor: "created_at",
    Cell: ({ value }) => {
      return <span>{value}</span>;
    },
  },
  {
    Header: "Notes",
    accessor: "rejection_note",
  },
];

const setIconPath = (icon) => {
  const path = process.env.REACT_APP_API_STORAGE_URL + "/" + icon;
  return path;
}
export const HISTORY_COLUMNS = [
  {
    Header: "Event",
    accessor: "name",
  },
  {
    Header: "Notes",
    accessor: "notes",
  },
  {
    Header: "Restrictions",
    accessor: "restrictions",
  },
  {
    Header: "Referrer",
    accessor: "referrer",
  },
  {
    Header: "Date",
    accessor: "journal_event_timestamp",
    Cell: ({ row, value }) => {
      return `${new Date(value).toLocaleDateString("en-US", {})}`;
    },
  },
  {
    Header: "Reference Document",
    accessor: "",
  },
  {
    Header: "Points",
    accessor: "amount",
  },
  {
    Header: "",
    accessor: "icon",
    // align: "center",
    Cell: ({ row, value }) => (
      !value ? '' : <img height={50} src={setIconPath(value)} alt="icons" />
    ),
  }
];

export const LEADERBOARD_AWARDS_COLUMNS = [
  {
    Header: "Event",
    accessor: "event",
  },
  {
    Header: "Notes",
    accessor: "notes",
  },
  {
    Header: "Restrictions",
    accessor: "restrictions",
  },
  {
    Header: "Referrer",
    accessor: "referrer",
  },
  {
    Header: "Date",
    accessor: "date",
  },
  {
    Header: "Reference Document",
    accessor: "",
  },
  {
    Header: "Points",
    accessor: "value",
     Cell: ({ row, value }) => {
        return value * 1;
      },
  },
];
